<template>
    <header>
        <div id="js_getHeaderHeight" class="ly_header">
            <div class="ly_header_inner">
                <p class="headerUtils_imgWrap">
                    <img :src="`${dir}/src/assets/img/logo-type-main.svg`"
                         alt="由数学協会"
                         class="headerUtils_img">
                </p>
                <nav class="d-none d-lg-flex headerNav">
                    <ul class="d-flex align-items-center headerNav_list ff_serif">
                        <li class="headerNav_item">
                            <router-link to="/" class="headerNav_link">Home</router-link>
                        </li>
                        <li class="headerNav_item">
                            <router-link to="/greeting" class="headerNav_link">ご挨拶</router-link>
                        </li>
                        <li class="headerNav_item">
                            <router-link to="/branch-introduction" class="headerNav_link">各支部校</router-link>
                        </li>
                        <li class="headerNav_item">
                            <router-link to="/contact" class="headerNav_link">お問い合わせ</router-link>
                        </li>
                        <li class="headerNav_item">
                            <router-link to="/sign-in" class="headerNav_link">SingIn</router-link>
                        </li>
                    </ul>
                    <p class="js_inPageLinks">
                        <router-link to="/entry-pre-seminar" class="el_btnA el_btnA__black">ENTRY</router-link>
                    </p>
                </nav>
            </div>
        </div>
        <Hamburger/>
        <ToggleMenu/>
    </header>
</template>

<script>
import Hamburger from './Hamburger.vue';
import ToggleMenu from './ToggleMenu.vue';

export default {
    data() {
        return {
            dir: DIR,
        }
    },
    components: {
        ToggleMenu,
        Hamburger,
    },
    // mounted() {
    //     this.$store.smoothScrollTo = Array.prototype.slice.call(document.getElementsByClassName('js_inPageLinks'));
    //     console.log(this.$store.inPageLinksElm);
    // },
}

</script>

<style scoped lang="scss" src="../../assets/scss/modules/header.scss">
</style>
